module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-panel uk-panel-box"
  }, [_vm._t("header", [(_vm.title) ? _c('h3', {
    staticClass: "tm-article-subtitle"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f30d41c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkPanel.vue
// module id = 297
// module chunks = 2